<template>
  <div>
    <v-layout>
      <v-dialog v-model="show" max-width="800px" lazy>
        <!-- <v-toolbar color="blue darken-2" dark>
          <v-icon large left>mdi-bullseye-arrow</v-icon>
          <v-toolbar-title>Evaluation</v-toolbar-title>
        </v-toolbar> -->
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >

          <v-toolbar card dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Evaluation</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <!-- <v-btn v-if="editedItem.id > 0" dark flat @click="updateItem">Update</v-btn> -->
              <v-btn dark flat @click="save">Save</v-btn>

            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md6 order-xs2 order-md1>
                  <v-flex xs12 class="text-xs-center text-sm-left">
                    <v-text-field
                      v-model="item.name"
                      @:keyup.enter="save"
                      label="Workers Name"
                    ></v-text-field>
                    <v-text-field
                      v-model="committee.committeeName"
                      @:keyup.enter="save"
                      label="Committee"
                    ></v-text-field>
                    <v-text-field
                      v-model="user.fullName"
                      @:keyup.enter="save"
                      label="Evaluator"
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex xs12 md6 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                  <img :src="item.picture" height="150" v-if="item.image"/>
                  <v-icon v-else x-large color="blue">person</v-icon>
                </v-flex>
                <v-flex xs12 order-xs3 class="text-xs-center text-sm-center">
                  <v-flex xs12 pt-4 class="text-xs-center text-sm-left">
                    <span class="title">Total Hours Worked</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      type="number"
                      v-model="editItem.hours"
                      @:keyup.enter="save"
                      label="Hours"
                      @change="setRequired()"
                      prepend-icon="mdi-alarm-check"
                    ></v-text-field>
                  </v-flex>
                  <v-layout wrap>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <v-switch v-model="editItem.noWork" @change="setRequired()" label="Did not work on committee"></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <v-switch v-model="editItem.excussed" @change="setRequired()" label="Excused from Committee duties and/or from this year's rodeo (Confirm with Manpower)"></v-switch>
                    </v-flex>
                    <v-flex v-if="editItem.excussed" xs12>
                      <v-textarea
                        v-model="editItem.excussedNotes"
                        label="Notes"
                        counter
                        maxlength="512"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-center">
                      <v-switch v-model="editItem.drop" label="Remove from Committee" prepend-icon="mdi-account-remove" color="red"></v-switch>
                    </v-flex>
                    <v-flex v-if="editItem.drop" xs12>
                      <v-textarea
                        v-model="editItem.dropNotes"
                        label="Notes"
                        counter
                        maxlength="512"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12 class="text-xs-center text-sm-left">
                    <p>
                      Please mark the statement that best describes the volunteer's work. If the volunteer was excused for this rodeo, only check "Excused".
                    </p>
                  </v-flex>
                  <v-layout wrap>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="title">Use the SMART method to evaluate volunteers:<br />
                      <span class="red--text">Specific</span>, <span class="yellow--text">Measurable</span>,
                      <span class="blue--text">Achievable</span>, <span class="blue--text">Relevant</span> and <span class="green--text">Timely</span></span>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">1. <b>Leadership</b> (Volunteer has demonstrated leadership abilities commensurate with many aspects of Committee management)
                      </span>
                      <v-select
                        v-model="editItem.attitudeWork"
                        :items="items"
                        item-text="text"
                        item-value="id"
                        label="Select"
                        :rules="[v => !!v || 'Field is required']"
                        :required="isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">2. <b>Knowledge of Position/Committee</b> (Volunteer has overall knowledge of the tasks and relationships)</span>
                      <v-select
                        v-model="editItem.attitudeRodeo"
                        :items="items"
                        item-text="text"
                        item-value="id"
                        label="Select"
                        :rules="[v => !!v || 'Field is required']"
                        :required="isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">3. <b>Quality of Work</b> (Volunteer is accurate, thorough, follows procedures, fulfills tasks)</span>
                      <v-select
                        v-model="editItem.locGuests"
                        :items="items"
                        item-text="text"
                        item-value="id"
                        label="Select"
                        :rules="[v => !!v || 'Field is required']"
                        :required="isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">4. <b>Dependability</b> (Volunteer is timely, attends shifts, punctual, is reliable)</span>
                      <v-select
                        v-model="editItem.locCommembers"
                        :items="items"
                        item-text="text"
                        item-value="id"
                        label="Select"
                        :rules="[v => !!v || 'Field is required']"
                        :required="isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">5. <b>Interpersonal Relationship</b> (Volunteer has a cooperative nature,  has a good rapport with other volunteers)</span>
                      <v-select
                        v-model="editItem.locComleaders"
                        :items="items"
                        item-text="text"
                        item-value="id"
                        label="Select"
                        :rules="[v => !!v || 'Field is required']"
                        :required="isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">6. <b>Personal Qualities</b> (Volunteer takes initiative, is creative, is flexible, is willing to help beyond their individual role)</span>
                      <v-select
                        v-model="editItem.profOntime"
                        :items="items"
                        item-text="text"
                        item-value="id"
                        label="Select"
                        :rules="[v => !!v || 'Field is required']"
                        :required="isRequired"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">7. <b>Comments:</b> (Concerns, Issues, Recommendations or Suggestions)</span>
                      </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        v-model="editItem.notes"
                        label="Notes"
                        counter
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12 pt-4 class="text-xs-center text-sm-left">
                      <span class="subheading">8. <b>Award</b></span>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center text-sm-center">
                      <v-switch v-model="editItem.award" label="Should be considered for a special award" prepend-icon="mdi-trophy-award"></v-switch>
                    </v-flex>
                    <v-flex v-if="editItem.award" xs12 class="text-xs-center text-sm-left">
                      <span class="subheading">Award Type</span>
                      <v-select
                        v-model="editItem.awardType"
                        :items="items2"
                        label="Select"
                      ></v-select>
                    </v-flex>
                    <v-flex v-if="editItem.award" xs12>
                      <v-textarea
                        v-model="editItem.awardNotes"
                        label="Please provide brief description of volunteer accomplishments"
                        counter
                        maxlength="512"
                        :required="editItem.award"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="item.title === 'Wrangler'" wrap>
                    <v-flex xs12 class="text-xs-center text-sm-center">
                      <v-switch v-model="editItem.membership" label="Recommended for Membership (Contingent on meeting eligibility requirements)" prepend-icon="mdi-account"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="blue darken-1"
              flat
              @click.stop="show=false"
            >Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              dark
              transition="fade-transition"
              @click.native="save"
            >Save</v-btn>
          </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['visible', 'item', 'committee'],

  data () {
    return {
      valid: true,
      saving: false,
      ratingText: {
        0: {
          text: 'Please select a rating'
        },
        1: {
          text: 'No show - no call - no work - Did not want to be on this Committee, not excused'
        },
        2: {
          text: 'Showed some of the time when scheduled -was not reliable'
        },
        3: {
          text: 'Showed when scheduled -  did a fair job'
        },
        4: {
          text: 'Showed when scheduled - did a good job. Met expectations'
        },
        5: {
          text: 'Showed when scheduled - did exceptional job, Way above and beyond expectations'
        }
      },
      items: [
        { text: 'Top Hand', id: 4 },
        { text: 'Exceeds Expectations', id: 3 },
        { text: 'Meets Expectations', id: 2 },
        { text: 'Needs Improvement', id: 1 }
      ],
      items2: [
        'Recognition Award - Reliable performance or positive behavior worth acknowledging',
        'Exceptional Contribution Award - Went beyond assigned duties through initiative, leadership, extra time, or improvements',
        'Top Hand Award (Reserved for Best of the Best ) - Exceptional impact, inspiring performance AND leadership and significant positive contribution to the Association'
      ],
      items3: [
        { text: 'Yes', id: 'Yes' },
        { text: 'No', id: 'No' }
      ],
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editItem: {
        id: 0,
        evaluator: this.$store.state.user.id,
        CommitteeId: this.$props.committee.committeeID,
        UserId: this.$props.item.id,
        attitudeWork: null,
        attitudeRodeo: null,
        locGuests: null,
        locCommembers: null,
        locComleaders: null,
        profOntime: null,
        profHours: null,
        profAssign: null,
        excussed: 0,
        excussedNotes: '',
        drop: 0,
        dropNotes: '',
        award: 0,
        awardNotes: '',
        hours: 0,
        notes: '',
        evalName: this.$store.state.user.fullName
      },
      editTo: false,
      isRequired: true,
      myHTML: '',
      files: []
    }
  },

  created () {
    // console.log('comm', this.committee)
    this.loadEval()
  },

  computed: {
    user () {
      return this.$store.state.user
    },

    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', this.editItem)
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        this.saving = true
      },
      deep: true
    }
  },

  methods: {
    loadEval () {
      // console.log('testa')

      if (this.$props.item.eval) {
        this.editItem = this.$props.item.eval
      }
    },

    loadItem () {
      // console.log(this.item)
    },

    setRequired () {
      console.log('test', this.isRequired)
      if (this.editItem.excussed === true || this.editItem.noWork === true) {
        this.isRequired = false
        this.editItem.attitudeWork = ' '
        this.editItem.attitudeRodeo = ' '
        this.editItem.locGuests = ' '
        this.editItem.locCommembers = ' '
        this.editItem.locComleaders = ' '
        this.editItem.profOntime = ' '
      } else {
        this.isRequired = true
        this.editItem.attitudeWork = ''
        this.editItem.attitudeRodeo = ''
        this.editItem.locGuests = ''
        this.editItem.locCommembers = ''
        this.editItem.locComleaders = ''
        this.editItem.profOntime = ''
      }
      console.log('test1', this.isRequired)
    },

    async save () {
      try {
        let response = null

        if (this.editItem.excussed || this.editItem.noWork) {
          this.isRequired = false
          this.editItem.attitudeWork = ' '
          this.editItem.attitudeRodeo = ' '
          this.editItem.locGuests = ' '
          this.editItem.locCommembers = ' '
          this.editItem.locComleaders = ' '
          this.editItem.profOntime = ' '
        }

        if (this.$refs.form.validate()) {
          if (this.editItem.excussed || this.editItem.noWork) {
            this.editItem.attitudeWork = null
            this.editItem.attitudeRodeo = null
            this.editItem.locGuests = null
            this.editItem.locCommembers = null
            this.editItem.locComleaders = null
            this.editItem.profOntime = null
            this.editItem.hours = 0
          }

          if (this.editItem.id > 0) {
            response = await Api().put('evals/' + this.editItem.id, this.editItem)
          } else {
            response = await Api().post('evals', this.editItem)

            this.editItem = response.data.evaluation
          }

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.show = false
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

input[type="file"]{
  position: absolute;
  top: -500px;
}

span.remove-file{
  color: red;
  cursor: pointer;
  float: right;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/EvalForm.vue